import React from 'react';
import {MasterLayout} from 'components/layouts';
import {RequestsContainer} from 'components/my-business/requests';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import {BusinessLayout} from 'components/layouts/business';
import title from 'constants/TitlePages.js';

class RequestsPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      business: this.props.business || {}
    }
  }

  componentDidMount() {
    document.title = title.MyBusinessRequests;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.business != this.state.business) {
      this.setState({
        business: nextProps.business
      })
    }
  }

  render() {
    return (
      <MasterLayout>
        <BusinessLayout active='mybusiness-requests'>
          <h1 className="user-header">Yêu cầu sản phẩm</h1>
          <RequestsContainer/>
        </BusinessLayout>
      </MasterLayout>
    );
  }
}

export default BusinessZone(RequestsPage);



// WEBPACK FOOTER //
// ./pages/my-business/Requests.jsx